export const columns = [
  // {
  //   title: "序号",
  //   width: 60,
  //   slots: { customRender: "index" },
  // },
  {
    title: "系统名称",
    width: 150,
    key: "systemName",
    slots: { customRender: "systemName" },
  },{
    title: "清单编号",
    width: 150,
    dataIndex: "bizNo",
    key: "bizNo",
  },
  {
    title: "材料编号",
    width: 150,
    dataIndex: "materialNo",
    key: "materialNo",
  },
  {
    title: "材料名称",
    width: 150,
    dataIndex: "materialName",
    key: "materialName",
  },
  {
    title: "规格型号",
    width: 150,
    dataIndex: "materialModel",
    key: "materialModel",
  },
  {
    title: "品牌",
    width: 200,
    dataIndex: "materialBrand",
    key: "materialBrand",
  },

  {
    title: "结算单位",
    width: 150,
    dataIndex: "materialUnit",
    key: "materialUnit",
  },
  {
    title: "当前合同",
    align: "center",
    children: [
      {
        title: "数量",
        width: 150,
        align: "right",
        dataIndex: "count",
        key: "count",
      },
      {
        title: "单价（￥）",
        width: 150,
        align: "right",
        dataIndex: "price",
        key: "price",
        slots: { customRender: "price" },
      },
      {
        title: "合价（￥）",
        width: 150,
        align: "right",
        dataIndex: "totalPrice",
        key: "totalPrice",
        slots: { customRender: "totalPrice" },
      },
    ],
  },
];
